"use client";

import type { FranchiseReview } from "@homeinstead/schemas";

import {
  Carousel,
  CarouselArrows,
  CarouselContent,
  CarouselItem,
} from "@homeinstead/ui/components/Carousel";
import {
  AvatarBackgroundVariants,
  ReviewCard,
} from "@homeinstead/ui/components/ReviewCard";
import React from "react";

const ReviewCarousel = ({
  title,
  reviews,
}: {
  title: string;
  reviews: FranchiseReview[];
}) => {
  if (!reviews || reviews.length === 0) {
    return null;
  }

  return (
    <Carousel>
      <div className="relative right-1/2 left-1/2 -mx-[50vw] w-screen bg-support-tints-400 pt-24 pb-12">
        <div className="px-10 xl:px-[152px]">
          <h3 className="mb-8 font-editorial-new font-light text-1xl">
            {title}
          </h3>
        </div>
        <CarouselContent className="mr-4 gap-4 pl-6 xl:pl-[152px]">
          {reviews.map((review, index) => (
            <CarouselItem
              className="mb-4 max-w-[368px] px-0 last:mr-8"
              key={index}
            >
              <ReviewCard
                avatarClassName={
                  AvatarBackgroundVariants[
                    index % AvatarBackgroundVariants.length
                  ]
                }
                className="h-[352px] w-[368px]"
                date={review.age}
                initials={(review.name || "A").charAt(0)}
                name={review.name || "Anonymous"}
                rating={review.rating}
                review={review.text}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        {reviews.length > 1 && (
          <CarouselArrows reviewsLength={reviews.length} />
        )}
      </div>
    </Carousel>
  );
};

export default ReviewCarousel;
